import { makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    address: {
        whiteSpace: "pre-wrap"
    }
});

const Address = () => {
    const { t } = useTranslation("contact");
    const styles = useStyles();
    
    return (
        <Text block className={styles.address}>
            {t("details.address.multiLine")}
        </Text>
    );
};

export default Address;